import React, { createContext, useContext, useState } from 'react';

type FormData = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
};

type FormContextType = {
  formData: FormData | null;
  setFormData: (data: FormData) => void;
};

const FormContext = createContext<FormContextType>({
  formData: {
    firstName: '',
    lastName: '',
    phone: '',
    email: ''
  },
  setFormData: () => {}
});

export const FormContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [formData, setFormData] = useState<FormData>({
    firstName: '',
    lastName: '',
    phone: '',
    email: ''
  });

  return <FormContext.Provider value={{ formData, setFormData }}>{children}</FormContext.Provider>;
};

export const useFormData = () => {
  const context = useContext(FormContext);

  if (!context) {
    throw new Error('useFormData must be used within FormContext.Provider');
  }

  return context;
};
